// src/components/ContatoFooter.js
import React from "react";
import "./ContatoFooter.css";

const ContatoFooter = () => {
  return (
    <footer id="contato" className="contato-footer-section">
      <div className="container">
        <div className="contato-content">
          <h2>Inicie sua jornada de estilo</h2>
          <p>
            Está pronta para revelar a imagem poderosa que existe em você? Entre
            em contato e vamos conversar sobre seus objetivos.
          </p>
          <a
            href="https://wa.me/5565981152009"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
          >
            Fale Comigo
          </a>
        </div>
        <div className="footer-bottom">
          <p>
            © {new Date().getFullYear()} Yvinna Patrícia | Desenvolvido com ♥
          </p>
          <div className="social-links">
            <a
              href="https://www.instagram.com/yvinnapatricia/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
            <span>•</span>
            <a href="#" target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
            <span>•</span>
            <a
              href="https://www.facebook.com/yvinnapatricia"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ContatoFooter;
